export default "__VITE_ASSET__Gr7D_dfV__"